/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var locales = require('../../../locales.cjs');
var configFindAllPaths = require('../../configFindAllPaths.cjs');
var $richText_styles = require('./_richText.styles.cjs');
var $richTextBlockElement = require('./_richTextBlockElement/_richTextBlockElement.cjs');
var range = require('../../../utils/src/array/range.cjs');
var nonNullable = require('../../../utils/src/array/nonNullable.cjs');
var dotNotationGet = require('../../../utils/src/object/dotNotationGet.cjs');

const editing = _ref => {
  let {
    values,
    params,
    editingInfo,
    __SECRET_INTERNALS__
  } = _ref;
  if (!__SECRET_INTERNALS__) {
    throw new Error("Missing __SECRET_INTERNALS__");
  }
  const {
    pathPrefix,
    editorContext
  } = __SECRET_INTERNALS__;
  const richTextConfig = dotNotationGet.dotNotationGet(editorContext.form.values, pathPrefix);
  const richTextBlockPaths = configFindAllPaths.configFindAllPaths(richTextConfig, editorContext, config => {
    return config._component === "@easyblocks/rich-text-block-element";
  });
  const richTextBlockPath = richTextBlockPaths.length > 0 ? `${pathPrefix}.${richTextBlockPaths[0]}` : undefined;
  const accessibilityRoleFieldIndex = editingInfo.fields.findIndex(field => field.path === "accessibilityRole");
  const fieldsBeforeAccessibilityRole = editingInfo.fields.slice(0, accessibilityRoleFieldIndex).filter(field => {
    if (field.path === "align" && params.passedAlign !== undefined) {
      return false;
    }
    return true;
  });
  const fieldsAfterAccessibilityRole = editingInfo.fields.slice(accessibilityRoleFieldIndex).map(field => {
    if (!richTextBlockPath) {
      return field;
    }
    const richTextBlockType = dotNotationGet.dotNotationGet(editorContext.form.values, `${richTextBlockPath}.type`);
    if (richTextBlockType !== "paragraph") {
      if (field.path === "accessibilityRole") {
        return {
          ...field,
          visible: false
        };
      }
      if (field.path === "isListStyleAuto") {
        return {
          ...field,
          visible: true
        };
      }
      if (!values.isListStyleAuto && (field.path === "mainFont" || field.path === "mainColor")) {
        return {
          ...field,
          visible: true
        };
      }
    }
    return field;
  });
  const richTextPartPaths = configFindAllPaths.configFindAllPaths(richTextConfig, editorContext, config => {
    return config._component === "@easyblocks/rich-text-part";
  });
  let currentLocaleRichTextPartPaths = richTextPartPaths.filter(isRichTextPartPathForLocale(editorContext.contextParams.locale));
  if (currentLocaleRichTextPartPaths.length === 0) {
    const fallbackLocale = locales.getFallbackLocaleForLocale(editorContext.contextParams.locale, editorContext.locales);
    if (fallbackLocale) {
      currentLocaleRichTextPartPaths = richTextPartPaths.filter(isRichTextPartPathForLocale(fallbackLocale));
    }
  }
  const richTextPartSources = currentLocaleRichTextPartPaths.map(path => `${pathPrefix}.${path}`);
  return {
    fields: [...fieldsBeforeAccessibilityRole, richTextPartSources.length > 0 ? {
      type: "field",
      path: richTextPartSources.map(source => `${source}.font`)
    } : null, richTextPartSources.length > 0 ? {
      type: "field",
      path: richTextPartSources.map(source => `${source}.color`)
    } : null, richTextBlockPath ? {
      type: "field",
      path: `${richTextBlockPath}.type`,
      label: "List style",
      group: "Text"
    } : null, ...fieldsAfterAccessibilityRole].filter(nonNullable.nonNullable())
  };
};
const richTextEditableComponent = {
  id: "@easyblocks/rich-text",
  label: "Text",
  thumbnail: "https://shopstory.s3.eu-central-1.amazonaws.com/picker_icon_text.png",
  schema: [{
    prop: "elements",
    type: "component-collection-localised",
    accepts: [$richTextBlockElement.richTextBlockElementEditableComponent.id],
    visible: false
  }, {
    prop: "align",
    label: "Align",
    type: "radio-group",
    responsive: true,
    params: {
      options: [{
        value: "left",
        label: "Left",
        icon: "AlignLeft",
        hideLabel: true
      }, {
        value: "center",
        label: "Center",
        icon: "AlignCenter",
        hideLabel: true
      }, {
        value: "right",
        label: "Right",
        icon: "AlignRight",
        hideLabel: true
      }]
    },
    defaultValue: "left",
    group: "Layout",
    buildOnly: true
  }, {
    prop: "accessibilityRole",
    type: "select",
    label: "Role",
    params: {
      options: [{
        value: "div",
        label: "Paragraph"
      }, ...range.range(1, 6).map(index => ({
        value: `h${index}`,
        label: `Heading ${index}`
      }))]
    },
    group: "Accessibility and SEO"
  }, {
    prop: "isListStyleAuto",
    type: "boolean",
    label: "Auto list styles",
    defaultValue: true,
    visible: false,
    group: "Text"
  }, {
    prop: "mainFont",
    type: "font",
    label: "Main font",
    visible: false,
    group: "Text"
  }, {
    prop: "mainColor",
    type: "color",
    label: "Main color",
    visible: false,
    group: "Text"
  }],
  type: "item",
  styles: $richText_styles.richTextStyles,
  editing
};
function isRichTextPartPathForLocale(locale) {
  return function innerIsLocalizedRichTextPart(richTextPartConfigPath) {
    return richTextPartConfigPath.startsWith(`elements.${locale}`);
  };
}

exports.richTextEditableComponent = richTextEditableComponent;
